export default "__VITE_ASSET__95d559e5__"